import { noop } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import * as v from "valibot"

import { $rqSmartFoldersApiClient } from "@/api/groups"
import { $rqNotificationsApiClient } from "@/api/notifications"
import { query } from "@/api/query"
import { $rqStorageTemplatesApiClient } from "@/api/storage"
import { getXOrganizationHeaders } from "@/api/utils"
import { routeGuard } from "@/lib/routing/beforeLoad"

const searchSchema = v.object({
  folderId: v.optional(v.string())
})

export const Route = createFileRoute("/_authlayout/_sidebar/triggers")({
  validateSearch: searchSchema,
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  loader: ({ context: { queryClient, spaceStorage } }) => {
    const space = spaceStorage.getSpace()

    queryClient.query({
      ...$rqNotificationsApiClient.queryOptions("get", "/notifications", {
        params: { header: getXOrganizationHeaders(space) }
      }),
      staleTime: "static"
    })
    queryClient.query({ ...query.space.members(space), staleTime: "static" })

    queryClient.query({
      ...$rqStorageTemplatesApiClient.queryOptions("post", "/storage/template/v1/list", {
        params: { header: getXOrganizationHeaders(space) },
        body: { sort: "asc", show_deleted: false }
      }),
      staleTime: "static"
    })

    queryClient
      .query(
        $rqSmartFoldersApiClient.queryOptions("get", "/groups/v1/smartfolders", {
          params: {
            header: getXOrganizationHeaders(space)
          }
        })
      )
      .catch(noop)
  },
  head: () => ({
    meta: [
      {
        title: "Triggers | Arduino Cloud"
      }
    ]
  })
})
